import { AppState } from './types'
import localCache from '@/utils/cache'
const state: AppState = {
  sidebar: {
    opened: localCache.getCache('sidebarStatus') !== undefined ? !!+localCache.getCache('sidebarStatus')! : true,
    withoutAnimation: false,
    hide: false
  },
  device: 'desktop',
  size: localCache.getCache('size') || 'medium'
}

const mutations = {
  TOGGLE_SIDEBAR: (state: AppState) => {
    if (state.sidebar.hide) {
      return false;
    }
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      localCache.setCache('sidebarStatus', '1')
    } else {
      localCache.setCache('sidebarStatus', '0')
    }
  },
  CLOSE_SIDEBAR: (state: AppState, withoutAnimation: boolean) => {
    localCache.setCache('sidebarStatus', '0')
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state: AppState, device: string) => {
    state.device = device
  },
  SET_SIZE: (state: AppState, size: string) => {
    state.size = size
    localCache.setCache('size', size)
  },
  SET_SIDEBAR_HIDE: (state: AppState, status: boolean) => {
    state.sidebar.hide = status
  }
}

interface ActionContext {
  commit: (type: string, payload?: any) => void;
}

const actions = {
  toggleSideBar({ commit }: ActionContext) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }: ActionContext, { withoutAnimation }: { withoutAnimation: boolean }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }: ActionContext, device: string) {
    commit('TOGGLE_DEVICE', device)
  },
  setSize({ commit }: ActionContext, size: string) {
    commit('SET_SIZE', size)
  },
  toggleSideBarHide({ commit }: ActionContext, status: boolean) {
    commit('SET_SIDEBAR_HIDE', status)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
} 